import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http';
import { ehsCBAPI } from '../../../environments/environment'
import { Question } from '../types/question.type';
import { QuestionContent } from '../types/question-content.type';
import { State } from '../types/state.type';

@Injectable()

export class QuestionService {

  constructor(private http: HttpClient) { }

  getQuestions() {
    return this.http.get<Question[]>(ehsCBAPI.endpoint + '/question');
  }

  getQuestionsBySubTopicId(topicId, subTopicId) {
    return this.http.get<Question[]>(ehsCBAPI.endpoint + '/question/' + topicId + '/' + subTopicId);
  }

  getQuestion(questionId) {
    return this.http.get<Question>(ehsCBAPI.endpoint + '/question/' + questionId + '/question');
  }

  getQuestionsLike(searchTerm) {
    return this.http.get<Question[]>(ehsCBAPI.endpoint + '/question?searchTerm=' + searchTerm);
  }

  getQuestionStates(questionId) {
    return this.http.get<State[]>(ehsCBAPI.endpoint + '/question/' + questionId + '/states');
  }

  getQuestionContents(questionId) {
    return this.http.get<State[]>(ehsCBAPI.endpoint + '/question/' + questionId + '/contents');
  }


  postQuestion(question) {
    return this.http.post<Question>(ehsCBAPI.endpoint + '/question', question);
  }

  postQuestionContent(questionContent) {
    return this.http.post<QuestionContent>(ehsCBAPI.endpoint + '/question-content', questionContent);
  }


  deleteQuestion(questionId) {
    return this.http.delete<Question>(ehsCBAPI.endpoint + '/question?questionId=' + questionId);
  }
}
